import { ApiBaseService, type ApiServiceConfig, type PaginatedFetch, type PaginatedFetchOptions } from "~/services/ApiBaseService";
import BlackListService, { type Unsubscribe } from "~/services/BlackListService";

export class SafetyLimitsService extends ApiBaseService {
    public black_list: BlackListService;

    constructor(config: ApiServiceConfig) {
        super(config);

        this.black_list = new BlackListService(config);
    }

    public listUnsubscribes(options?: PaginatedFetchOptions<Unsubscribe>): PaginatedFetch<Unsubscribe> {
        return this.paginate(
            this.route("api.unsubscribes.index", "/safety-limits/unsubscribes"),
            options,
        );
    }
}